export default "__VITE_ASSET__DDyzHpPA__"